import BaseController from '../BaseController';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { PanelAPI } from '@philips-internal/oswald-ui-components';

import { ScheduleType } from '../../constants/schedule-type';
import { APPOINTMENT_TYPE } from '../../constants/appointment-type';
import './appointment-confirmation.css';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { Value } from '@philips-internal/oswald-ui-core';
import { Data } from '../../interfaces/data';
import UserContext from '../../utils/user-context';
import { ScheduleConfirmationAliases } from '../../codegen';
import { ContextType } from '@philips-internal/oswald-ui-core';

interface ScheduleInfo {
  ieStatus: string;
  ieTipoAgendamento: string;
  nrSequencia: number;
}

@Controller({ component: 'layout-confirmation', fragment: 'schedule-confirmation' })
class AppointmentConfirmationModalController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(ScheduleConfirmationAliases.PANEL_CONTEXTUALBAR_APPOINTMENTS)
    panelContextualBarAppointmentsAPI!: PanelAPI;

  @Inject(ScheduleConfirmationAliases.PANEL_CONTEXTUALBAR_REQUESTS)
    panelContextualBarRequestsAPI!: PanelAPI;

  @Inject(ScheduleConfirmationAliases.PANEL_CONTEXTUALBAR_WAITINGLIST)
    panelContextualBarWaitinglistAPI!: PanelAPI;

  @OnMount({ target: ScheduleConfirmationAliases.LAYOUT_APPOINTMENT_DETAIL_CONTENT_SCHEDULE_CONFIRMATION })
  async onMount(event: MountEvent): Promise<void> {
    if (event) {
      const context = this.context as unknown as Record<string, Value>;
      const scheduleInfoList = context.data as ScheduleInfo[];
      const scheduleList: Data[] = [];
      const scheduleRequestList: Data[] = [];
      const scheduleWaitingList: Data[] = [];
      for (const scheduleInfo of scheduleInfoList) {
        if(scheduleInfo.nrSequencia == null) {
          continue;
        }
        const ieTipoAgendamento = this.parseScheduleType(scheduleInfo.ieTipoAgendamento);
        const params = {
          appointmentType: ieTipoAgendamento,
          ieScheduleType: scheduleInfo.ieStatus,
          nrSeq: scheduleInfo.nrSequencia,
          patientId: UserContext.patientId,
        }
        if(scheduleInfo.ieStatus === 'W') {
          params.appointmentType = APPOINTMENT_TYPE.WAITING_LIST;
        }

        await HttpService.get(APPLICATION_ENDPOINTS.APPOINTMENT_DETAIL, params).then(response => {
          const appointment = response.body as Record<string, Value>;
          switch (params?.ieScheduleType) {
            case 'R':
              scheduleRequestList.push(appointment as Data);
              break;
            case 'W':
              scheduleWaitingList.push(appointment as Data);
              break;
            default:
              scheduleList.push(appointment as Data);
              break;
          }
        })
      }
      setTimeout(() => {
        if(scheduleList.length > 0) {
          this.panelContextualBarAppointmentsAPI.setVisible(true);
          this.context.set({appointment_confirmation_list: { data: scheduleList, isConfirmationResult: true}});
        }
        if(scheduleRequestList.length > 0) {
          this.panelContextualBarRequestsAPI.setVisible(true);
          this.context.set({appointment_confirmation_list: { data: scheduleRequestList, isConfirmationResult: true}});
        }
        if(scheduleWaitingList.length > 0) {
          this.panelContextualBarWaitinglistAPI.setVisible(true);
          this.context.set({appointment_confirmation_list: { data: scheduleWaitingList, isConfirmationResult: true}});
        }
      });
    }
  }

  parseScheduleType(ieTipoAgendamento: string): string {
    if (ieTipoAgendamento) {
      switch(ieTipoAgendamento) {
        case ScheduleType.CONSULTATION: return APPOINTMENT_TYPE.CONSULTATIONS;
        case ScheduleType.EXAM: return APPOINTMENT_TYPE.EXAMS;
        case ScheduleType.SERVICE: return APPOINTMENT_TYPE.SERVICES;
        case ScheduleType.SURGERY: return APPOINTMENT_TYPE.SURGERIES;
        case ScheduleType.CHEMOTHERAPY: return APPOINTMENT_TYPE.CHEMOTHERAPIES;
      }
    }
    return '';
  }

}

export default AppointmentConfirmationModalController;
